

import { types } from "../types"


export const pushAccessList = (list, isAdmin, role, userAccess, bottomLinks) => {

    return {
        type: types.PUSH_ACCESS_LIST,
        list, isAdmin, role, userAccess, bottomLinks
    }
}

export const emptyAccess = () => {
    return {
        type: types.EMPTY_ACCESS_LIST
    }
}

export const selectUserByAdminAction = (user) => {

    return {
        type: types.SELECT_USER_BY_ADMIN,
        user
    }
}

export const emptySelectedUserByAdminAction = () => {
    return {
        type: types.EMPTY_SELECTED_USER_BY_ADMIN
    }
}